// 案件サブシステム。スケジュールは jobs/:id より先に置く（:id に "schedule" が食われないように）。
const meta = (menu) => ({ requiresAuth: true, requiresBizhub: true, ...(menu ? { menu } : {}) });
export default [
  { path: "todo", name: "BizhubTodo", component: () => import("@/views/Bizhub/TodoView.vue"),
    meta: meta({ group: "案件", title: "やること", order: 5 }) },
  { path: "jobs", name: "BizhubJobs", component: () => import("@/views/Bizhub/JobListView.vue"),
    meta: meta({ group: "案件", title: "案件一覧", order: 10 }) },
  // 問い合わせの画面はやめた（2026-11-05）。迷うものは「やること」のお願いに出る。古い URL はやることへ
  { path: "inquiries", name: "BizhubInquiries", redirect: { name: "BizhubTodo" }, meta: meta() },
  { path: "jobs/schedule", name: "BizhubSchedule", component: () => import("@/views/Bizhub/JobScheduleView.vue"),
    meta: meta({ group: "案件", title: "スケジュール", order: 20 }) },
  { path: "slips", name: "BizhubShipping", component: () => import("@/views/Bizhub/ShippingPrepView.vue"),
    meta: meta({ group: "案件", title: "出荷準備", order: 25 }) },
  { path: "slips/:id", name: "BizhubSlip", component: () => import("@/views/Bizhub/RentalSlipView.vue"), meta: meta() },
  { path: "jobs/:id", name: "BizhubJobDetail", component: () => import("@/views/Bizhub/JobDetailView.vue"), meta: meta() },
  { path: "jobs/:id/slips/:slipId/print", name: "BizhubSlipPrint", component: () => import("@/views/Bizhub/RentalSlipPrintView.vue"), meta: meta() },
];
